module.exports = __webpack_public_path__ + "media/test-mode9.7b956c2e.mp4";